import React from "react";

interface CardProps {
  title?: string;
  description?: string;
  color?: "primary" | "secondary" | "default" | "white" | "danger" | "warning"; // to apply custom background color to the card
  icon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  rightIconClick?: () => void;
  children?: React.ReactNode;
  stackTitleAndDescription?: boolean;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
  title = "",
  description = "",
  color = "default", // default background color is primary
  icon,
  rightIcon,
  rightIconClick,
  children,
  stackTitleAndDescription = false, // default: old behavior
  onClick,
}) => {
  const colorClass = {
    primary: "var(--app-primary)",
    secondary: "var(--app-primary)",
    default: "var(--card-background)",
    white: "#ffffff",
    danger: "#DC2626",
    warning: "#F59E0B",
  };
  // Get the current color value
  const currentColor = colorClass[color];
  return (
    <div
      className="relative rounded-lg p-4 border"
      style={{ backgroundColor: currentColor, borderColor: "var(--card-border)" }}
      onClick={onClick}
    >
      {rightIcon && (
        <button
          className="absolute top-2 right-2 text-sm text-[var(--text-secondary)] p-2 hover:bg-gray-100 rounded-full"
          onClick={rightIconClick}
        >
          {rightIcon}
        </button>
      )}

      {stackTitleAndDescription ? (
        // New layout
        <div className="flex items-start gap-4">
          {icon && <div className="pt-0.5">{icon}</div>}
          <div className="flex-1 min-w-0">
            <p
              className="text-smd font-medium"
              style={{ color: "var(--card-title-color)" }}
            >
              {title}
            </p>
            {description && (
              <p
                className="text-sm mt-1"
                style={{ color: "var(--card-desc-color)" }}
              >
                {description}
              </p>
            )}
          </div>
        </div>
      ) : (
        // Old layout
        <div
          className="-mx-4 px-4 mb-4"
          style={{ borderBottom: "1px solid var(--card-border)" }}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3 -mt-1 mb-1">
              <div className="bg-[var(--app-secondary)] text-white text-xs p-1 rounded-md">
                {icon}
              </div>
              <span
                className="text-smd font-medium"
                style={{ color: "var(--card-title-color)" }}
              >
                {title}
              </span>
            </div>
          </div>
          {/* This is the new layout for the description */}
          <div
            className="text-sm font-thin mb-4"
            style={{ color: "var(--card-desc-color)" }}
          >
            {description && <div>{description}</div>}
          </div>
          {/* This is the old layout for the description */}
          {/* {description && (
            <div className="text-sm text-gray-500 font-thin mb-4">
              {description}
            </div>
          )} */}
        </div>
      )}

      <div className="">{children}</div>
    </div>
  );
};

export default Card;
